module.exports = __webpack_public_path__ + "img/car.743bd6f7.png";